import { render, staticRenderFns } from "./CirclesProportionalDashboardItem.vue?vue&type=template&id=c93dbd4e"
import script from "./CirclesProportionalDashboardItem.vue?vue&type=script&lang=js"
export * from "./CirclesProportionalDashboardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c93dbd4e')) {
      api.createRecord('c93dbd4e', component.options)
    } else {
      api.reload('c93dbd4e', component.options)
    }
    module.hot.accept("./CirclesProportionalDashboardItem.vue?vue&type=template&id=c93dbd4e", function () {
      api.rerender('c93dbd4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/CirclesProportionalDashboardItem.vue"
export default component.exports